import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const WhiteLoader = () => {
  return (
    <>
      <Container style={{ paddingTop: "3px", paddingBottom: "6%" }}>
        <Row className="justify-content-md-center">
          <Col xs lg="2" style={{ textAlign: "center" }}>
            <Spinner animation="border" style={{ color: "#fff" }} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WhiteLoader;
